import { useCallback, useEffect, useRef, useState } from "react";
import { IVacationChangeRequest } from "@vmosolutions/oc-interfaces";

import { getVacationChangeRequests } from "../helpers";

export interface IChangeRequestHistory {
  requests: IVacationChangeRequest[];
  reload: () => void;
}

/** Every change request made in a package, loaded while `enabled`, for showing as history. */
export const useChangeRequestHistory = (packageId: string | undefined, enabled: boolean): IChangeRequestHistory => {
  const [loaded, setLoaded] = useState<{ packageId?: string; requests: IVacationChangeRequest[] }>({ requests: [] });
  // Only the latest load may land, so a slow one cannot overwrite a newer one or another package's.
  const latestLoad = useRef<number>(0);

  const reload = useCallback(() => {
    if (!packageId || !enabled) return;
    const load = ++latestLoad.current;
    void getVacationChangeRequests(packageId).then((view) => {
      if (load === latestLoad.current && view) setLoaded({ packageId, requests: view.requests });
    });
  }, [packageId, enabled]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { requests: loaded.packageId === packageId ? loaded.requests : [], reload };
};
